import { render, staticRenderFns } from "./MessageOutline.vue?vue&type=template&id=0d247942"
import script from "./MessageOutline.vue?vue&type=script&lang=js"
export * from "./MessageOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports